var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeUmidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06037 29.8616C5.97999 29.8616 4.29588 27.7419 4.29588 25.1276C4.29588 22.5132 5.97999 20.3935 8.06037 20.3935C10.1408 20.3935 11.8249 22.5132 11.8249 25.1276C11.8249 27.7419 10.1408 29.8616 8.06037 29.8616ZM13.5 0C13.5 0 0 12.1443 0 22.9107C0 30.1354 6.04307 36 13.5 36C20.957 36 27 30.1443 27 22.9107C27 12.2237 13.5 0 13.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeUmidade);
export default __webpack_public_path__ + "static/media/iconeUmidade.f8036a1c640b64cf4ae14f79d29bb298.svg";
export { ForwardRef as ReactComponent };